export default [
  {path: '/videoNewInfo/:html', name: '视频详情', component: () => import('@/view/videoNewInfo/videoNewInfo'), meta: {title: '视频详情', }, },
  // {path: '/caseVideo/:type/:page/:html', name: '案例视频', component: () => import('@/view/caseVideo/caseVideo'), meta: {title: '案例视频', }, },//减肥案例
  {path: '/caseVideo/:html', name: '案例视频', component: () => import('@/view/caseVideo/caseVideo'), meta: {title: '案例视频', }, },//减肥案例
  // {path: '/encyclopeDias/:id/:type/:page/:html', name: 'encyclopeDias', component: () => import('@/view/encyclopeDias/encyclopeDias'), meta: {title: '减肥视频', }, },//减肥视频
  {path: '/encyclopeDias/:html', name: 'encyclopeDias', component: () => import('@/view/encyclopeDias/encyclopeDias'), meta: {title: '减肥视频', }, },//减肥视频
  {path: '/videoKeyList/:key/:page/:html', name: 'videoKeyList', component: () => import('@/view/videoKeyList/videoKeyList'), meta: {title: '视频关键字', }, }, // 视频关键字列表页  ，作息管理-详情
];



// WEBPACK FOOTER //
// src/router/video.js